import React from "react";
import { PastDueSubscriptionWidgetTemplate } from "themes/application/payment/components";

function PastDueSubscriptionWidget(props) {
    return <PastDueSubscriptionWidgetTemplate {...props} />;
}

export default PastDueSubscriptionWidget;
